import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import { ModalTemplate, Button as Btn } from 'components';

import { CtTargetEdit } from 'containers';

import classNames from 'classnames/bind';
import styles from './AdminTargetEditModal.css';
const cx = classNames.bind(styles);

class AdminTargetEditModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editInvalid: false,
      editOnProgress: true,
      editSaveNow: false,
      disableSave: false
    };
  }

  setDisableSave = value => {
    const stateObj = {};
    if (this.state.disableSave !== value) {
      stateObj.disableSave = value;
    }
    if (!value && this.state.editSaveNow) {
      stateObj.editSaveNow = false;
    }
    this.setState(stateObj);
  };

  setEditInvalid = value => {
    if (this.state.editInvalid !== value) {
      const stateObj = {
        editInvalid: value
      };
      this.setState(stateObj);
    }
  };

  setEditOnProgress = value => {
    if (this.state.editOnProgress !== value) {
      this.setState({ editOnProgress: value });
    }
  };

  dispatchSave = () => {
    this.setState({
      editSaveNow: true
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { disableSave, editInvalid, editOnProgress, editSaveNow } = this.state;
    const { isAuth, targetInfo, addMode, mountEditModal } = this.props;
    const { setDisableSave, setEditInvalid, setEditOnProgress, dispatchSave } = this;

    let targetNumber = '';
    if (targetInfo && targetInfo.targetNo) {
      targetNumber = ' ( No. ' + targetInfo.targetNo + ' )';
    } else if (targetInfo === undefined) {
      targetNumber = targetNumber;
    }

    const renderData =
      isAuth === 2 ? (
        <ModalTemplate
          closeOnEscape={false}
          closeOnDimmerClick={false}
          closeOnDocumentClick={false}
          className={cx('modal-user-edit modal-admin tiny', 'common-content')}
          closeIcon={<Icon name="close" link />}
          onToggleModal={mountEditModal}
          visible
          header={
            <div>
              {defineMessages(formatMessage({ id: 'TargetEdit_1', defaultMessage: '대상자' })) +
                ' ' +
                (addMode
                  ? defineMessages(formatMessage({ id: 'AdminUserEditModal_2', defaultMessage: '등록' }))
                  : defineMessages(formatMessage({ id: 'AdminUserEditModal_3', defaultMessage: '수정' }))) +
                targetNumber}
            </div>
          }
          buttons={
            <div className={cx('inline-block')}>
              <Btn buttonColor="#bbbbbb" onClick={mountEditModal}>
                {defineMessages(formatMessage({ id: 'AdminUserEditModal_4', defaultMessage: '취 소' }))}
              </Btn>
              <Btn
                className={cx('brand-button')}
                loading={editOnProgress}
                disabled={disableSave && (editInvalid || editOnProgress)}
                onClick={dispatchSave}>
                {defineMessages(formatMessage({ id: 'AdminUserEditModal_5', defaultMessage: '저 장' }))}
              </Btn>
            </div>
          }>
          <CtTargetEdit
            addMode={addMode}
            targetInfo={targetInfo}
            editSaveNow={editSaveNow}
            setEditInvalid={setEditInvalid}
            setEditOnProgress={setEditOnProgress}
            setDisableSave={setDisableSave}
            handleOnToggleEditModal={mountEditModal}
          />
        </ModalTemplate>
      ) : null;

    return renderData;
  }
}

export default injectIntl(AdminTargetEditModal);



// WEBPACK FOOTER //
// ./src/script/components/admin/target/AdminTargetEditModal.js